import { TOGGLE_OKTELL_SYNC } from "../../CONSTANTS";

export default function toggleOktellSync() {
  return {
    type: TOGGLE_OKTELL_SYNC,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/actions/calls/toggleOktellSync.js